import { HistoryScreen } from '@/features/history/HistoryScreen';

export function HistoryPage() {
  return (
    <main className="flex flex-col">
      <h1 className="px-6 pt-8 font-display text-h1 text-text">История</h1>
      <HistoryScreen />
    </main>
  );
}
